import { apiCall } from "api-calls/api-call"
import {
  CreateGamePublisher,
  GamePublisher,
  UpdateGamePublisher,
} from "../store/game-publishers.store"

export const getGamePublishers = async(page: number, limit: number) => {
  const query = { page, limit }

  return await apiCall({
    method: "GET",
    path: "buff-play/game-publishers",
    query,
  })
}

export const updateGamePublisher = async(
  id: string,
  data: UpdateGamePublisher,
): Promise<GamePublisher> => {
  return await apiCall({
    method: "PUT",
    path: `buff-play/game-publishers/${id}`,
    body: data,
  })
}

export const createGamePublisher = async(
  data: CreateGamePublisher,
): Promise<GamePublisher> => {
  return await apiCall({
    method: "POST",
    path: "buff-play/game-publishers",
    body: data,
  })
}
